/* esm.sh - lib0@0.2.117/trait/equality */
var o=Symbol("Equality"),a=(t,l)=>t===l||!!t?.[o]?.(l)||!1;export{o as EqualityTraitSymbol,a as equals};
//# sourceMappingURL=equality.mjs.map